(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

    function createMobileComparison(root) {
      if (!MOBILE_QUERY.matches || root.classList.contains('product-comparison--mobile-enhanced')) return;

      const sourceTable = root.querySelector(':scope > .product-comparison__scroll > .product-comparison__table');
      if (!sourceTable) return;

      const mobileComparison = document.createElement('div');
      mobileComparison.className = 'product-comparison__mobile-comparison';

      const mobileList = document.createElement('div');
      mobileList.className = 'product-comparison__mobile-list';
      mobileList.setAttribute('role', 'region');
      mobileList.setAttribute('aria-label', root.querySelector('.product-comparison__scroll')?.getAttribute('aria-label') || 'Product comparison');

      const scrollers = [];
      let columnCount = 0;
      sourceTable.querySelectorAll('tr').forEach((sourceRow) => {
        const cells = [...sourceRow.children];
        if (cells.length < 2) return;
        columnCount = Math.max(columnCount, cells.length - 1);

        const row = document.createElement('div');
        row.className = 'product-comparison__mobile-row';

        const label = document.createElement('div');
        label.className = 'product-comparison__mobile-label';
        label.innerHTML = cells[0].innerHTML;

        const scroller = document.createElement('div');
        scroller.className = 'product-comparison__mobile-scroller';
        scroller.tabIndex = 0;

        const track = document.createElement('div');
        track.className = 'product-comparison__mobile-track';
        cells.slice(1).forEach((cell) => {
          const copy = document.createElement('div');
          copy.className = `${cell.className} product-comparison__mobile-cell`;
          copy.innerHTML = cell.innerHTML;
          track.append(copy);
        });

        scroller.append(track);
        row.append(label, scroller);
        mobileList.append(row);
        scrollers.push(scroller);
      });

      const scrollbar = document.createElement('div');
      scrollbar.className = 'product-comparison__mobile-scrollbar';
      scrollbar.tabIndex = 0;
      scrollbar.setAttribute('aria-label', 'Scroll product comparison');
      const scrollbarTrack = document.createElement('div');
      scrollbarTrack.className = 'product-comparison__mobile-scrollbar-track';
      scrollbarTrack.style.width = `${columnCount * 140}px`;
      scrollbar.append(scrollbarTrack);

      let synchronizing = false;
      const scrollables = [...scrollers, scrollbar];
      scrollables.forEach((scroller) => {
        scroller.addEventListener('scroll', () => {
          if (synchronizing) return;
          synchronizing = true;
          scrollables.forEach((otherScroller) => {
            if (otherScroller !== scroller) otherScroller.scrollLeft = scroller.scrollLeft;
          });
          synchronizing = false;
        }, { passive: true });
      });

      mobileComparison.append(mobileList, scrollbar);
      root.append(mobileComparison);
      root.classList.add('product-comparison--mobile-enhanced');
    }

    function initializeComparisons() {
      document.querySelectorAll('.product-comparison').forEach(createMobileComparison);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeComparisons, { once: true });
    } else {
      initializeComparisons();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
